export const newsData = [
    {
        id: 1,
        img: '/images/samples/300x300/3.jpg',
        title: 'Card Title That Wraps To A New Line',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad blanditiis quam, sequi dolorum excepturi repudiandae atque dignissimos voluptatum aperiam!'
    },
    {
        id: 2,
        img: '/images/samples/300x300/9.jpg',
        title: 'Card Title That Wraps To A New Line',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad blanditiis quam, sequi dolorum excepturi repudiandae atque dignissimos voluptatum aperiam!'
    },
    {
        id: 3,
        img: '/images/samples/300x300/5.jpg',
        title: 'Card Title That Wraps To A New Line',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad blanditiis quam, sequi dolorum excepturi repudiandae atque dignissimos voluptatum aperiam!'
    },
    {
        id: 4,
        img: '/images/samples/300x300/2.jpg',
        title: 'Card Title That Wraps To A New Line',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad blanditiis quam, sequi dolorum excepturi repudiandae atque dignissimos voluptatum aperiam!'
    },
    {
        id: 5,
        img: '/images/samples/300x300/8.jpg',
        title: 'Card Title That Wraps To A New Line',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad blanditiis quam, sequi dolorum excepturi repudiandae atque dignissimos voluptatum aperiam!'
    },
    {
        id: 6,
        img: '/images/samples/300x300/6.jpg',
        title: 'Card Title That Wraps To A New Line',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad blanditiis quam, sequi dolorum excepturi repudiandae atque dignissimos voluptatum aperiam!'
    },
    {
        id: 7,
        img: '/images/samples/300x300/8.jpg',
        title: 'Card Title That Wraps To A New Line',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad blanditiis quam, sequi dolorum excepturi repudiandae atque dignissimos voluptatum aperiam!'
    },
    {
        id: 8,
        img: '/images/samples/300x300/10.jpg',
        title: 'Card Title That Wraps To A New Line',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad blanditiis quam, sequi dolorum excepturi repudiandae atque dignissimos voluptatum aperiam!'
    },
    {
        id: 9,
        img: '/images/samples/300x300/3.jpg',
        title: 'Card Title That Wraps To A New Line',
        description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Ad blanditiis quam, sequi dolorum excepturi repudiandae atque dignissimos voluptatum aperiam!'
    },
]